import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { hasValue } from './typeChecks';
import { truncate } from './util';
import { parseErrors, prepareError } from './validationError';

export var BaseResourceError = function () {
    function BaseResourceError(message) {
        _classCallCheck(this, BaseResourceError);

        this._message = message;
    }

    _createClass(BaseResourceError, [{
        key: 'toString',
        value: function toString() {
            return this._message;
        }
    }, {
        key: 'isNetworkError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }, {
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }, {
        key: 'isValidationError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }]);

    return BaseResourceError;
}();

export var NetworkError = function (_BaseResourceError) {
    _inherits(NetworkError, _BaseResourceError);

    function NetworkError(error) {
        _classCallCheck(this, NetworkError);

        var _this = _possibleConstructorReturn(this, (NetworkError.__proto__ || _Object$getPrototypeOf(NetworkError)).call(this, 'NetworkError'));

        _this.error = error;
        return _this;
    }

    _createClass(NetworkError, [{
        key: 'isNetworkError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }]);

    return NetworkError;
}(BaseResourceError);

export var InvalidResponseCode = function (_BaseResourceError2) {
    _inherits(InvalidResponseCode, _BaseResourceError2);

    function InvalidResponseCode(statusCode, responseText) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'InvalidResponseCode';

        _classCallCheck(this, InvalidResponseCode);

        var _this2 = _possibleConstructorReturn(this, (InvalidResponseCode.__proto__ || _Object$getPrototypeOf(InvalidResponseCode)).call(this, type + ' ' + statusCode + ': ' + truncate(responseText, 256)));

        _this2.statusCode = statusCode;
        _this2.responseText = responseText;
        return _this2;
    }

    _createClass(InvalidResponseCode, [{
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }]);

    return InvalidResponseCode;
}(BaseResourceError);

export var RequestValidationError = function (_InvalidResponseCode) {
    _inherits(RequestValidationError, _InvalidResponseCode);

    function RequestValidationError(statusCode, responseText) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, RequestValidationError);

        // Set custom config
        var _this3 = _possibleConstructorReturn(this, (RequestValidationError.__proto__ || _Object$getPrototypeOf(RequestValidationError)).call(this, statusCode, responseText, 'RequestValidationError'));

        _this3._customConfig = _extends({
            parseErrors: parseErrors,
            prepareError: prepareError
        }, config || {});

        // parse response body as a ValidationError
        _this3._errors = _this3._customConfig.parseErrors(responseText, _this3._customConfig);
        return _this3;
    }

    // public api


    _createClass(RequestValidationError, [{
        key: 'hasError',
        value: function hasError() {
            return hasValue(this._errors) && this._errors.hasError();
        }
    }, {
        key: 'isValidationError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }, {
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }, {
        key: 'errors',
        get: function get() {
            return this._errors;
        }
    }]);

    return RequestValidationError;
}(InvalidResponseCode);